import React from 'react'

// Tipo para PaymentDate
type SelectedWorkUnitAndBusinessUnit = {
  parent_id?: number | null
  phone?: string | null
  config?: any
  client_id: number
  email?: string
  logo?: string | null
  id: number
  user_id?: number
  contact?: string
  hash_business_unit: string
  fiscal_data_id?: number
  state?: string
  short_name: string
  token: string
  country_id?: number
  long_name: string
  is_agency?: boolean
  business_type_id?: number
  description?: string
  agency_id?: number | null
  work_unit_id?: number
  fantasy_name?: string
  is_active: boolean
  salesperson_user_id?: number
  address?: string
  salesperson_user_id_relation?: any
  client_relation?: any
  children?: any[]
  currency_relation?: any[]
  user_relation?: any[]
  business_type?: any
  work_unit?: any
}

export type PaymentType = {
  payment_type: number
  id_payment: number
  details: null | any
  apply_extra_cost: boolean
  date: string
  amount_to_pay: number
  code: string
}

export type Reservation = {
  number: string | null
  passenger: string | null
  user_id: number | null
}

export type FormData = {
  business_unit: number | null
  credit_or_payment_type: string | null
  currency: number | null
  paymentType: PaymentType[] | null
  credit: any | null
  reservation: Reservation | null
}

export type PaymentData = {
  work_unit_token: string | null
  work_unit_id: number | null
  hash_work_unit: string | null
  selectedWorkUnit: SelectedWorkUnitAndBusinessUnit | null
  hash_business_unit: string | null
  selectedBusinessUnit: SelectedWorkUnitAndBusinessUnit | null
  form_data: FormData
  initialValues: object | null
  extraCostSuccessStates: object | null
  rowStyle: object | null
  is_back: boolean
}

// Tipo para PaymentCurrencies
type CurrencyRelation = {
  hash_currency: string
  long_name: string
  id: number
  symbol: string
  short_name: string
}

export type PaymentExchange = {
  is_reverse: boolean
  value: number
  currency_id: number
  currency_to_id: number
  work_unit_id: number
  currency_relation: CurrencyRelation
  currency_to_relation: CurrencyRelation
}

export type PaymentCurrency = {
  id: number
  long_name: string
  short_name: string
  symbol: string
  hash_currency: string
}

// Context Type
type PaymentContextType = {
  reservationIds: number[]
  setReservationIds: (reservationIds: number[]) => void
  paymentData: PaymentData
  setPaymentData: (paymentDate: PaymentData) => void
  paymentCurrecies: PaymentCurrency[]
  setPaymentCurrecies: (currency: PaymentCurrency[]) => void
  paymentExchanges: PaymentExchange[]
  setPaymentExchanges: (exchange: PaymentExchange[]) => void
  itemsSelected: any[]
  setItemsSelected: (itemSelected: any[]) => void
  paymentCredit: any[]
  setPaymentCredit: (paymentCredit: any[]) => void
  currency: any
  setCurrency: (paymentCredit: any) => void
  isReservationOption: boolean
  setIsReservationOption: (isReservationOption: boolean) => void
}

export const PaymentContext = React.createContext<PaymentContextType>({
  reservationIds: [],
  setReservationIds: () => {},
  paymentData: {
    work_unit_token: null,
    work_unit_id: null,
    hash_work_unit: null,
    selectedWorkUnit: null,
    hash_business_unit: null,
    selectedBusinessUnit: null,
    form_data: {
      business_unit: null,
      credit_or_payment_type: null,
      currency: null,
      paymentType: null,
      credit: null,
      reservation: {
        number: null,
        passenger: null,
        user_id: null,
      },
    },
    initialValues: null,
    extraCostSuccessStates: null,
    rowStyle: null,
    is_back: false,
  },
  setPaymentData: () => {},
  paymentCurrecies: [],
  setPaymentCurrecies: () => {},
  paymentExchanges: [],
  setPaymentExchanges: () => {},
  itemsSelected: [],
  setItemsSelected: () => {},
  paymentCredit: [],
  setPaymentCredit: () => {},
  currency: {},
  setCurrency: () => {},
  isReservationOption: false,
  setIsReservationOption: () => {},
})

export const usePaymentContext = () => React.useContext(PaymentContext)
